import { render, staticRenderFns } from "./EditServiceCharge.vue?vue&type=template&id=0032d96e&scoped=true"
import script from "./EditServiceCharge.vue?vue&type=script&lang=js"
export * from "./EditServiceCharge.vue?vue&type=script&lang=js"
import style0 from "./EditServiceCharge.vue?vue&type=style&index=0&id=0032d96e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0032d96e",
  null
  
)

export default component.exports